/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Tooltip, Typography } from '@astro-ui/components'
import { BusinessTaggingValueType } from 'features/SupplyOrder/services/outboundSO'

type BusinessTaggingConfigType = {
  textColor: string
  bgColor: string
  borderColor: string
}

type BusinessTaggingValueEnum = BusinessTaggingValueType | 'OTHER'

export const BusinessTagging_CONFIG: Record<BusinessTaggingValueEnum, BusinessTaggingConfigType> = {
  SCHEDULE_DELIVERY: {
    textColor: '#23575C',
    bgColor: '#DEF7FA',
    borderColor: '#BCF0F5',
  },
  ASTRO_GO: {
    textColor: '#804300',
    bgColor: '#FFF3E6',
    borderColor: '#FFE7CC',
  },
  QUICK_COMMERCE: {
    textColor: '#00552E',
    bgColor: '#E6F7EF',
    borderColor: '#CCEEDE',
  },
  OTHER: {
    textColor: '#212121',
    bgColor: '#E9E9E9',
    borderColor: '#D3D3D3',
  },
}

type BusinessTaggingChipPropsType = {
  label: string
  name: BusinessTaggingValueEnum
}

export const BusinessTaggingChip = ({ label, name }: BusinessTaggingChipPropsType) => {
  const config = BusinessTagging_CONFIG[name as BusinessTaggingValueEnum] || {
    textColor: '#212121',
    bgColor: '#E9E9E9',
    borderColor: '#D3D3D3',
  }

  const backgroundColor = config.bgColor
  const { textColor } = config
  const { borderColor } = config

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      px="12px"
      py="4px"
      borderRadius="32px"
      border="1px solid"
      borderColor={borderColor}
      bg={backgroundColor}
    >
      <Typography variant="body-smallStrong" sx={{ color: textColor }} whiteSpace="nowrap">
        {label}
      </Typography>
    </Box>
  )
}

type BusinessTaggingListPropsType = {
  items: {
    id: number
    key: BusinessTaggingValueEnum
    type: string
    value: string
  }[]
  maxVisible?: number
}

export const BusinessTaggingChipList = ({
  items,
  maxVisible = 3,
}: BusinessTaggingListPropsType) => {
  if (!items.length) return null

  const isOverflow = items.length > maxVisible

  const visibleCount = isOverflow ? Math.max(1, maxVisible - 1) : items.length

  const visibleItems = items.slice(0, visibleCount)
  const hiddenItems = items.slice(visibleCount)

  return (
    <Box display="flex" gap="8px" flexWrap="wrap">
      {visibleItems.map((item) => (
        <BusinessTaggingChip key={item.key} name={item.key} label={item.value} />
      ))}

      {isOverflow && hiddenItems.length > 0 && (
        <Tooltip
          arrow
          placement="bottom"
          title={
            <Box display="flex" flexDirection="column" gap="4px">
              {hiddenItems.map((item) => (
                <Typography key={item.id} variant="body-small" sx={{ color: '#fff' }}>
                  {item.value}
                </Typography>
              ))}
            </Box>
          }
        >
          <Box>
            <BusinessTaggingChip name="OTHER" label={`+${hiddenItems.length} lainnya`} />
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}
